import React from 'react';
import { Link } from 'react-router-dom';
import { getSubdomainUrl } from '@/lib/utils/subdomain';

export function CommunityNotFound() {
  const platformUrl = getSubdomainUrl('platform', '/signup');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Community Not Found
            </h2>
            <div className="mb-6 text-gray-600">
              <p>This community doesn't exist or hasn't been created yet.</p>
            </div>
            <a
              href={platformUrl}
              className="text-indigo-600 hover:text-indigo-500"
            >
              Create your community
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
